import { Component, Input, OnInit } from '@angular/core';
import { LibraryService } from '../../../core/services/library/library.service';

@Component({
    standalone: false,
    selector: 'app-no-results',
    templateUrl: './no-results.component.html',
    styleUrls: ['./no-results.component.scss'],
})
export class NoResultsComponent implements OnInit {
    @Input() searchText: string = '';

    constructor(private libraryService: LibraryService) {}

    ngOnInit(): void {}

    get noResultLabel(): string {
        return this.libraryService.getLabel('no_results').replace('###STR###', this.searchText);
    }
}
